import { createFileRoute } from "@tanstack/react-router";
import { SpaceOverview } from "@/components/items/SpaceOverview";

export const Route = createFileRoute("/_app/s/$spaceKey")({ component: Space });

function Space() {
  const { spaceKey } = Route.useParams();
  return <SpaceOverview spaceKey={spaceKey} />;
}
